import { BrandingDetails } from '@/constants'

export function formatDocumentTitle(pageTitle?: string | null): string {
	const page = pageTitle?.trim()
	if (!page || page === BrandingDetails.PAGE_TITLE_PREFIX) {
		return BrandingDetails.PAGE_TITLE_PREFIX
	}

	return `${page} | ${BrandingDetails.PAGE_TITLE_PREFIX}`
}
